import { DataTable as RWMC, DataTableProps as RWMCProps } from "@rmwc/data-table"
import { HTMLAttributes } from "react"
import omit from "lodash/omit"
import { callCSSFn, CSS, CSSFn, styled, StylePropsWithCSS } from "../../styles"

export type DataTableProps = RWMCProps &
  HTMLAttributes<HTMLTableElement> & {
    css?: CSSFn
  }
const Component = (props: DataTableProps) => <RWMC {...omit(props, `css`)} />
Component.defaultProps = {
  css: undefined,
}
export const DataTable = styled(Component)(
  (props: StylePropsWithCSS): CSS => ({
    width: `100%`,
    marginBottom: props.theme.spacing(5),
    border: `none`,
    "& table": {
      borderSpacing: 0,
    },
    ...callCSSFn(props),
  })
)
